"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hidden = exports.notRequired = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _introspection = require("./internal/introspection");

var notRequiredCache;

var notRequired = function notRequired(propType) {
  if (propType == null) return propType;
  notRequiredCache = notRequiredCache || new WeakMap();

  if (!notRequiredCache.has(propType)) {
    var notRequiredPropType = function notRequiredPropType(props, propName) {
      if (props[propName] == null) return null;

      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }

      return propType.apply(void 0, [props, propName].concat(rest));
    };

    notRequiredPropType.getType = propType.getType;

    if (propType.__INTROSPECTION__) {
      notRequiredPropType.__INTROSPECTION__ = (0, _extends2.default)({}, propType.__INTROSPECTION__, {
        isRequired: false
      });
    }

    notRequiredCache.set(propType, notRequiredPropType);
  }

  return notRequiredCache.get(propType);
};

exports.notRequired = notRequired;
var hiddenCache;

var hidden = function hidden(propType) {
  if (propType == null) return propType;
  hiddenCache = hiddenCache || new WeakMap();

  if (!hiddenCache.has(propType)) {
    var hiddenPropType = function hiddenPropType() {
      return propType.apply(void 0, arguments);
    };

    hiddenPropType.getType = propType.getType;

    if (propType.__INTROSPECTION__) {
      hiddenPropType.__INTROSPECTION__ = (0, _extends2.default)({}, propType.__INTROSPECTION__, {
        isHidden: true
      });
    } else if ((0, _introspection.isIntrospectionEnabled)()) {
      hiddenPropType.__INTROSPECTION__ = {
        isHidden: true
      };
    }

    hiddenCache.set(propType, hiddenPropType);
  }

  return hiddenCache.get(propType);
};

exports.hidden = hidden;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/utils/propTypes/decorators.js
// module id = 60
// module chunks = 0